(function initSize() {
    let windowWidth = document.documentElement.clientWidth | document.body.width;
    let size = ((windowWidth > 640 ? 640 : windowWidth) / 750) * 20;
    document.documentElement.style.fontSize = (size > 60 ? 60 : size) + "px";
})();


// WEBPACK FOOTER //
// ./src/assets/js/rem.js